import { useEffect, useRef } from 'react'
import { when } from 'mobx'
import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { FeatureRestrictedModalStore } from 'entities/UsersPermissions'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useContactsPageContext } from 'pages/contacts/context/contactsPageContext'
import { ContactsRoutes } from '../type'

export const ImportRoute = observer(() => {
  const { importContactsStore } = useContactsPageContext()
  const { userPermissionsStore } = useEntitiesContext()
  const allPath = `/${ContactsRoutes.root}/${ContactsRoutes.all}`
  const isImportModalOpen = importContactsStore.isImportModalOpen
  const wasOpenRef = useRef(false)

  useEffect(() => {
    // Wait for permissions to load before deciding (see NewContactRoute).
    const disposePermission = when(
      () => !userPermissionsStore.loading,
      () => {
        if (!userPermissionsStore.getItem('can_create_contacts')) {
          new FeatureRestrictedModalStore('can_create_contacts', () =>
            uiStore.changeRoute({ path: allPath, method: 'replace' })
          )

          return
        }

        if (!importContactsStore.isImportModalOpen) {
          importContactsStore.openModal()
        }
      }
    )

    return () => {
      disposePermission()
      if (importContactsStore.isImportModalOpen) {
        importContactsStore.closeActiveModal()
      }
    }
  }, [])

  // Modal dismissed via its own X/backdrop/Esc: sync URL to /all so + Import works again.
  useEffect(() => {
    if (isImportModalOpen) {
      wasOpenRef.current = true
    } else if (wasOpenRef.current) {
      uiStore.changeRoute({ path: allPath, method: 'replace' })
    }
  }, [isImportModalOpen])

  return null
})
